<template lang="jade">
.tip-detail
  .tip-detail__desc
    .tip-detail__item(
      v-for="item in detailDesc", 
      :key="item.type",:ref="`tip-info-${item.type}`")
      .tip-detail__item-title
        | {{item.title}}
      .tip-detail__item-desc(v-html="replaceWrap(item.desc)")
</template>

<script>
const baseUrl = "https://static.piaoniu.com/pn/public/gpxz/";

export default {
  props: {
    activity: Object,
  },
  data() {
    return {
      baseUrl,
      tabActive: 1,
    };
  },
  computed: {
    detailDesc() {
      const { ticketTip, enterTip } = this.activity;
      console.log("detailDesc", [...ticketTip.detail, ...enterTip.detail]);
      return [...ticketTip.detail, ...enterTip.detail];
    },
  },
  methods: {
    selectTab(index) {
      this.tabActive = index;
    },
    replaceWrap(str) {
      return str.replace(/\n/g, "<br/>");
    },
  },
};
</script>

<style lang="less" scoped>
.tip-detail {
  &__item {
    &::after {
      content: "";
      display: block;
      margin-bottom: 12px;
      width: 100%;
      height: 1px;
      background-color: #f5f5f5;
    }
    &:last-child::after {
      display: none;
    }
  }
  &__item-title {
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    color: #262626;
  }
  &__item-desc {
    color: #666666;
    font-weight: 400;
    font-size: 11px;
    line-height: 16px;
    margin: 6px 0 12px;
  }
}
</style>



// WEBPACK FOOTER //
// TipInfo.vue?2c502bd5